var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-checkbox"},[_c('input',_vm._g(_vm._b({staticClass:"custom-checkbox__input",attrs:{"type":"checkbox"}},'input',Object.assign({}, _vm.$attrs,
      {checked: _vm.checked,
      class: [{ indeterminate: _vm.indeterminate }, _vm.color],
      disabled: _vm.disabled}),false),Object.assign({}, _vm.$listeners,
      {change: function ($event) { return _vm.$emit('change', $event.target.checked); }}))),_c('span',{staticClass:"custom-checkbox__icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }